const presetSelect = {
    hasBuilderButton: true,
    hasNormsTab: false,
  }
  
  export default presetSelect
  export { presetSelect }
  


// WEBPACK FOOTER //
// ./src/app/configuration/ComcastPremarket/config/components/selection/PresetSelect/index.js